module.exports = __webpack_public_path__ + "img/esc_1_act_4.52df881d.png";